import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { forwardRef } from 'react';
import { cn, Spinner, FaIcon } from '@fe-learner-common';
import { ButtonProps } from './Button';

interface IconButtonProps extends ButtonProps {
  icon: IconDefinition;
}

const Icon = ({ icon }: { icon: IconDefinition }) => (
  <FaIcon
    className="lf:aspect-square lf:text-inherit"
    icon={icon}
    width={16}
    height={16}
  />
);

const iconSizeMap = {
  sm: 'lf:w-8 lf:h-8',
  md: 'lf:w-10 lf:h-10',
  lg: 'lf:w-12 lf:h-12',
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, icon, loading, name, size, ariaLabel, ...rest }, ref) => {
    return (
      <button
        {...rest}
        aria-label={ariaLabel}
        ref={ref}
        className={cn(
          'lf:l-btn',
          'lf:flex lf:shrink-0 lf:rounded-lg',
          iconSizeMap[size],
          'lf:disabled:cursor-default',
          className,
        )}
      >
        {loading ? <Spinner name={name} /> : <Icon icon={icon} />}
      </button>
    );
  },
);
IconButton.displayName = 'IconButton';

export const TertiaryIconButton = forwardRef<
  HTMLButtonElement,
  IconButtonProps
>(({ className, ...rest }, ref) => {
  return (
    <IconButton
      className={cn('lf:l-btn-tertiary', className)}
      ref={ref}
      {...rest}
    />
  );
});
TertiaryIconButton.displayName = 'TertiaryIconButton';
